<div class="modal-header bg-white">
  <h5 class="modal-title" id="staticBackdropLabel" *ngIf="entity" i18n="@@TransactionDialogHeaderTitle">
    Details zum Ladevorgang {{ entity.transactionId }}
  </h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onCancelClick()"></button>
</div>
<div class="modal-body">
  <app-details-transaction #detailsTransaction
    (entityLoadedEvent)="onEntityLoadedEvent($event)"></app-details-transaction>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center h4 pb-2">
        {{ entity?.successMessage }}
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row ">
      <div class="col-4 text-center rounded-1 pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-zap big-icons">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
      </div>
      <div class="col-4 text-center rounded-1 pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-battery-charging big-icons">
          <path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path>
          <line x1="23" y1="13" x2="23" y2="11"></line>
          <polyline points="11 6 7 12 13 12 9 18"></polyline>
        </svg>
      </div>
      <div class="col-4 text-center rounded-1 pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-zap-off big-icons">
          <polyline points="12.41 6.75 13 2 10.57 4.92"></polyline>
          <polyline points="18.57 12.91 21 10 15.66 10"></polyline>
          <polyline points="8 8 3 14 12 14 11 22 16 16"></polyline>
          <line x1="1" y1="1" x2="23" y2="23"></line>
        </svg>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-center my-2">{{ entity?.startTimestamp | date: 'medium' }}</div>
      <div class="col-4 text-center my-2">{{ entity?.meterAmount | kwh }} kWh</div>
      <div class="col-4 text-center my-2">{{ entity?.stopTimestamp | date: 'medium' }} </div>
    </div>
  </div>

  <div id="MeterValuesChart" style="height: 28vh; width: 100%; background-color: rgb(255, 255, 255);">
    <div *ngIf="chartIsLoading" class="loading-spinner-container" style="height:300px;">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingChartHint">
          Grafik wird generiert
        </span>
      </div>
    </div>
    <canvas id="distribution-chart-canvas"
              style="display: block; box-sizing: border-box; max-width: 100%; height:300px;"></canvas>

  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center pt-3">
        <button type="button" id="download_sighedmtervalues" class="btn btn-yellow"
          (click)="downloadSignedMeterValues()" i18n="@@DownloadSignedMeterValues" [disabled]="!fileExists">
          <app-svg source="icons/feather/download" class="p-0" height="18"></app-svg>
          <span>&ensp;Signierte Daten herunterladen</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-end">
  <button type="button" id="cancel" style="height:35px;" class="btn btn-yellow" data-bs-dismiss="modal"
    (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
</div>
